export const getHeaderWithAnchorsHeight = () => {
    function getCssVariableValue(variableName: string): number {
        const value = getComputedStyle(document.documentElement).getPropertyValue(variableName).trim();
        return parseFloat(value);
    }
    // небольшой фикс отступа от начала блока, чтобы не было видно предыдущий блок
    const offset = 5;
    const headerHeight = getCssVariableValue('--header-height') || 0;
    const anchorsHeight = getCssVariableValue('--anchors-height') - offset || 0;

    return headerHeight + anchorsHeight;
};
